import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import './Delivery.scss';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import { toast } from 'react-toastify';
import PedidosDisplayer from './components/PedidosDisplayer/PedidosDisplayer';
import PedidosListener from '../Common/PedidosListener/PedidosListener';
import { getActiveDeliveryPedidosByLocalId } from '../../../../crud/pedidos_api/pedidos';
import { getAllBuiltMenusByLocalIdV2 }     from '../../../../crud/menu_api/menus';
import { localIsOpen }                     from '../../../../crud/management_api/locales_caja_management';
import LocalClosedModal from '../Common/LocalClosed/LocalClosedModal';
import { FaPlus, FaCog } from 'react-icons/fa';
import CreatePedido from './components/CreatePedido/CreatePedido';
import DeliveryConfig from './components/DeliveryConfig/DeliveryConfig';
import {  usePedidos } from '../PedidosContext';

const PaginaMenu: React.FC = () => {
  const [showLocalClosedModal, setShowLocalClosedModal] = useState(false);
  const [showCreatePedido, setShowCreatePedido]   = useState(false);
  const [showDeliveryConfig, setShowDeliveryConfig] = useState(false);
  const { pedidos, setPedidos }                     = usePedidos();
  const [loading, setLoading]                     = useState(false);
  const [redir,setRedir] = useState<number>(500)

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      try {
        const user    = JSON.parse(localStorage.getItem('user') || '{}');
        const localId = user.local_id;

        const [menusRes, openRes, pedidosRes] = await Promise.all([
          getAllBuiltMenusByLocalIdV2(localId, 'Delivery'),
          localIsOpen(localId),
          getActiveDeliveryPedidosByLocalId(localId),
        ]);

        // store menus
        localStorage.setItem('localMenus', JSON.stringify(menusRes.data));

        // check open status
        if (openRes.status !==200) {
          setRedir(openRes.status)
          setShowLocalClosedModal(true);
        }

        // set pedidos
        setPedidos(pedidosRes.data);
      } catch (err: any) {
        console.error('Error initializing page:', err);
        toast.error('Error cargando datos de delivery');
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // setPedidos is stable from context, safe to omit

  const renderHeader = () => (
    <div className="delivery-header-container">
      <h2 className="delivery-title">Delivery</h2>
      <div className="delivery-buttons">
    
        <Button 
          onClick={() => setShowDeliveryConfig(true)}
        >
          <FaCog /> Configuración
        </Button>
    
        {pedidos.length > 0 && (
          <Button onClick={() => setShowCreatePedido(true)}>
            <FaPlus /> Nuevo Pedido
          </Button>
        )}
      </div>
    </div>
  );

  if (loading) {
    return (
      <LoadingSpinner
        text="Cargando datos de delivery..."
        transparent={true}
      />
    );
  }

  const renderNoData = () => (
    <div className="no-data-available">
      <div className="no-data-available-message">
        No hay pedidos activos!
      </div>
      <Button
        className="no-data-available-button"
        onClick={() => setShowCreatePedido(true)}
      >
        Tomar Pedido
      </Button>
    </div>
  );

  return (
    <>
      <PedidosListener 
      setPedidos={setPedidos}
      pedido_type_id={3} />
      {renderHeader()}
      {showDeliveryConfig ? (
        <DeliveryConfig onClose={() => setShowDeliveryConfig(false)} />
      ) : (
        <>
          {pedidos.length === 0
            ? renderNoData()
            : <PedidosDisplayer pedidos={pedidos} setPedidos={setPedidos} />
          }
        </>
      )}
      <CreatePedido
        show={showCreatePedido}
        handleClose={() => setShowCreatePedido(false)}
        pedidos={pedidos}
        setPedidos={setPedidos}
      />
      <LocalClosedModal show={showLocalClosedModal} redir={redir} />
    </>
  );
};

export default PaginaMenu;
